import {
	SET_NOTIFICATION_TYPES,
	SET_EVENT_PREFERENCES,
	UPDATE_EVENT_PREFERENCE,
} from '../actions/actionTypes';

import { arrToObj } from '@/redux/util';

const preState = {
	notificationTypes: [],
	eventPreferences: {},
};

const notificationPreferencesReducer = (state = preState, action) => {
	Object.freeze(state);
	const stateDup = { ...state };
	const { type, notificationTypes, eventNotificationPreferences, eventPreference } = action;

	switch (type) {
		case SET_NOTIFICATION_TYPES:
			return { ...stateDup, notificationTypes };
		case SET_EVENT_PREFERENCES:
			return {
				...stateDup,
				eventPreferences: arrToObj(eventNotificationPreferences, null, 'notification_type_id'),
			};
		case UPDATE_EVENT_PREFERENCE:
			const { notification_type_id } = eventPreference;
			stateDup.eventPreferences[notification_type_id] = eventPreference;
			return { ...stateDup, eventPreferences: { ...stateDup.eventPreferences } };
		default:
			return stateDup;
	}
};

export default notificationPreferencesReducer;
